// extracted by mini-css-extract-plugin
module.exports = {"Buttons":"UwUqRYcpbQtl6kfa0fS56w==","Buttons_submit":"EF1SFRxOH0GyyMzNfTOFbQ==","without_width":"hRfYt-++jXk9Wdy0KB8D0w==","Buttons_back":"Jvsv5a0LlZa9SANzAuboJA=="};